// extracted by mini-css-extract-plugin
export default {"BannerOne":"BannerOne_BannerOne__ae86c","quote":"BannerOne_quote__fWYWW","cover":"BannerOne_cover__CeewP","content":"BannerOne_content__HVsVK","p":"BannerOne_p__gnCCU"};